<template>
    <auth-modal
        v-if="showAuthModal"
        :redirect-on-success="true"
        @close="showAuthModal = false"
        @authenticated="onAuthenticated"
    />

    <header class="header" :class="{'header_menu-opened' : openMenu}">
        <div class="row align-items-center">
            <div class="col-3 header__burger_wrap">
                <div class="hamburger_wrap">
                    <button class="hamburger hamburger--squeeze" :class="{'is-active' : openMenu}" type="button" @click="changeMenuState">
							<span class="hamburger-box">
								<span class="hamburger-inner"></span>
							</span>
                    </button>
                </div>
            </div>
            <div class="col-lg-2 col-6 header__logo_wrap">
                <div class="header__logo">
                    <router-link to="/">
                        <img :src="logoLinks" v-if="logoLinks">
                        <img src="../../../assets/img/logo.png" v-if="logoLinks === null">
                    </router-link>
                </div>
            </div>
            <div class="col-lg-8 header__menu_wrap">
                <div class="header__menu">
                    <router-link to="/">Главная</router-link>
                    <router-link
                        :to="{ name: 'Schedule', query: this.$store.state.user.current_club ? { club: this.$store.state.user.current_club } : {} }"
                    >
                        Расписание
                    </router-link>
                    <router-link to="/reservations">Мои записи</router-link>
                    <router-link to="/items">Абонементы и услуги</router-link>
                    <router-link to="/shop">Магазин</router-link>
                </div>
                <div class="header__download_app">
                    <a :href="this.$store.getters.storeLinks.apple_store" v-if="this.isIOSDevice && this.$store.getters.storeLinks.apple_store !== ''">
                        <img src="../../../assets/img/app_store.png" alt="">
                    </a>
                    <a :href="this.$store.getters.storeLinks.google_play" v-else-if="this.$store.getters.storeLinks.google_play !== ''">
                        <img src="../../../assets/img/google_play.png" alt="">
                    </a>
                </div>
            </div>
            <div class="col-lg-2 col-3 header__profile_wrap">
                <div class="header__profile">
                    <div class="header__profile_btn">
                        <span class="header__profile_btn-text">
                            {{ auth ? this.$store.getters.userName : 'Войти' }}
                        </span>

                        <span class="header__profile_btn-icon">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="32" height="32" rx="10" fill="#3C67D6"/>
                                <path d="M15.9097 14.9284C16.8615 14.9284 17.6857 14.5871 18.3592 13.9135C19.0326 13.2401 19.374 12.4161 19.374 11.4641C19.374 10.5125 19.0326 9.68838 18.3591 9.01472C17.6855 8.34139 16.8614 8 15.9097 8C14.9577 8 14.1337 8.34139 13.4603 9.01483C12.7868 9.68827 12.4453 10.5124 12.4453 11.4641C12.4453 12.4161 12.7868 13.2402 13.4604 13.9136C14.1339 14.5869 14.958 14.9284 15.9097 14.9284Z" fill="white"/>
                                <path d="M21.9709 19.0601C21.9515 18.7798 21.9122 18.4741 21.8544 18.1512C21.796 17.826 21.7208 17.5185 21.6308 17.2375C21.5379 16.947 21.4115 16.6602 21.2552 16.3853C21.093 16.1 20.9025 15.8515 20.6888 15.6471C20.4652 15.4332 20.1916 15.2613 19.8751 15.1358C19.5597 15.0111 19.2102 14.9479 18.8363 14.9479C18.6895 14.9479 18.5475 15.0081 18.2733 15.1866C18.1045 15.2967 17.9071 15.424 17.6867 15.5648C17.4983 15.6848 17.2431 15.7973 16.9278 15.8992C16.6202 15.9987 16.3079 16.0492 15.9997 16.0492C15.6914 16.0492 15.3792 15.9987 15.0713 15.8992C14.7564 15.7974 14.5011 15.685 14.3129 15.5649C14.0947 15.4254 13.8971 15.2981 13.7258 15.1865C13.4519 15.008 13.3098 14.9478 13.163 14.9478C12.789 14.9478 12.4396 15.0111 12.1244 15.1359C11.8081 15.2612 11.5343 15.4331 11.3106 15.6472C11.0969 15.8518 10.9063 16.1001 10.7443 16.3853C10.5882 16.6602 10.4618 16.9469 10.3687 17.2376C10.2788 17.5186 10.2037 17.826 10.1453 18.1512C10.0875 18.4736 10.0482 18.7795 10.0288 19.0604C10.0097 19.3356 10 19.6213 10 19.9097C10 20.6606 10.2387 21.2684 10.7093 21.7166C11.1742 22.159 11.7892 22.3834 12.5372 22.3834H19.4628C20.2108 22.3834 20.8256 22.1591 21.2906 21.7166C21.7613 21.2687 22 20.6608 22 19.9096C21.9999 19.6198 21.9901 19.334 21.9709 19.0601Z" fill="white"/>
                            </svg>
                        </span>

                        <ul class="header__profile_btn-dropdown">
                          <li v-if="auth && clubs.length >= 2" @click="goToChangeCurrentClub">
                            <i><img src="../../../assets/img/location.svg"></i> Выбрать филиал
                          </li>
                          <li v-if="auth" @click="goToDocuments">
                            <i><img src="../../../assets/img/documents.svg"></i> Документы
                          </li>
                          <li v-if="auth" @click="goToCards">
                            <i><img src="../../../assets/img/card.svg" alt=""></i> Мои карты
                          </li>
                           <li @click="changeLoginState">
                               <i>
                                   <img v-if="auth" src="../../../assets/img/logout.svg" alt="">
                                   <img v-else src="../../../assets/img/login.svg" alt="">
                               </i>
                               {{ auth ? 'Выйти из аккаунта' : 'Войти' }}
                           </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>

    import AuthModal from '../../../components/AuthModal.vue'

    export default {
        name: 'HeaderLayout',
        components: { AuthModal },
        data() {
            return {
                clubs: [],
                showAuthModal: false,
            }
        },
        mounted() {
          this.loadClubs();
        },
        computed: {
            auth() {
                return !!this.$store.state.token
            },
            openMenu: function() {
                return this.$store.getters.isMenuOpened
            },
            isIOSDevice: function() {
                return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
            },
            logoLinks: function () {
              return this.$store.getters.logoLinks
            },
        },
        methods: {
            changeLoginState(){
                if (this.auth){
                    localStorage.removeItem('fitbase_token')
                    this.$store.commit('SET_TOKEN', null)
                    window.dispatchEvent(new CustomEvent('fitbase-auth-changed', {
                      detail: {
                        token: null
                      }
                    }))
                    this.$router.push({name: 'Login'})
                } else {
                    this.showAuthModal = true
                }
            },
            onAuthenticated() {
                this.showAuthModal = false
            },
            changeMenuState(){
                if (this.openMenu){
                    this.$store.commit('HIDE_MENU')
                }else{
                    this.$store.commit('SHOW_MENU')
                }
            },
            goToChangeCurrentClub() {
                this.$router.push('/changeClub');
            },
            goToDocuments() {
                this.$router.push('/docs');
            },
            goToCards() {
                this.$router.push('/cards');
            },
            async loadClubs() {
                try {
                    const response = await this.$store.dispatch('optionsClub');
                    this.clubs = response.data;
                } catch (e) {
                    this.errors = ['Ошибка при загрузке филиалов'];
                }
            },
        }
    }
</script>
